import { Gray, Plain } from '../../constants';
import type { MotifComponent, MotifComponentProps } from '../../motif';

export const footnoteVars: MotifComponentProps<MotifComponent.FOOTNOTE> = {
  '--footnote-fg-color': Gray.V300,
  '--footnote-bg-color': Plain.WHITE,
};
